import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=d170b42a&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=d170b42a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d170b42a",
  null
  
)

export default component.exports